import { PasswordRules } from 'services/requests';
import { ChangePasswordFieldNames } from 'hooks/forms';
import { getPasswordRequirementState } from 'utils';

export type PasswordsRequirements = {
  newPassword: PasswordRules;
  repeatNewPassword: PasswordRules;
};
export const passwordsRequirementsReducer = (
  state: PasswordsRequirements,
  action: { type: string; password: string },
): PasswordsRequirements => {
  switch (action.type) {
    case ChangePasswordFieldNames.newPassword:
      return {
        ...state,
        newPassword: getPasswordRequirementState(action.password),
      };
    case ChangePasswordFieldNames.repeatNewPassword:
      return {
        ...state,
        repeatNewPassword: getPasswordRequirementState(action.password),
      };
    default:
      return state;
  }
};

const passwordRequirements = {
  matchLength: false,
  includeUppercase: false,
  includeLowercase: false,
  includeNumber: false,
  includeSpecialSymbol: false,
};

export const passwordsRequirementsInitialData: PasswordsRequirements = {
  newPassword: passwordRequirements,
  repeatNewPassword: passwordRequirements,
};

export const actionUpdateNewPassword = (password: string) => ({
  type: ChangePasswordFieldNames.newPassword,
  password,
});

export const actionUpdateRepeatNewPassword = (password: string) => ({
  type: ChangePasswordFieldNames.repeatNewPassword,
  password,
});
